module.exports = __webpack_public_path__ + "img/nav-budget-1.6d6f3ca.svg";